module.exports = __webpack_public_path__ + "static/media/card-premier.80bb1d01.png";